// extracted by mini-css-extract-plugin
export default {"block":"Condition_block__Udan8","void":"Condition_void__gEUns","text":"Condition_text__aFVy3"};